export default __webpack_public_path__ + "static/media/tool_screen_shot.8da785fd.svg";